<template>
  <b-modal :ref="id" :id="id" :title="$t('file-manager.file-no-and-account')" scrollable size="lg" title-class="font-18" @hidden="onHide">
    <div>
      <div v-if="form.fileNoOption == 'select'" class="mt-2">
        <label>{{ $t("file-manager.no") }}</label>

        <div class="d-flex flex-row">
          <div class="w-95 ">
            <filter-select id="no-filter" ref="no-filter" :placeholder="$t('file-manager.no')" :multiple="false" @filter="onNoSearch" @changed="noSelect" />
          </div>
          <div class="mt-1 ml-2" v-b-tooltip.hover :title="$t('file-manager.new-file-no')">
            <i
              class="iconoir-plus font-size-24 hand"
              @click="
                form.fileNoOption = 'create';
                formfileNo = undefined;
              "
            ></i>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex  flex-row">
          <div class="w-95">
            <sweet-input
              class="mt-1"
              v-model="form.fileNo"
              :isValid="!$v.form.fileNo.$error"
              @input="$v.form.fileNo.$touch()"
              layout="vertical"
              :placeholder="$t('file-manager.no')"
              :label="$t('file-manager.no')"
            />
          </div>

          <div class="mt-2" v-b-tooltip.hover :title="$t('common.select')">
            <i
              class="bx bx-select-multiple font-size-24 hand mt-4 ml-2"
              @click="
                form.fileNoOption = 'select';
                form.fileNo = undefined;
              "
            ></i>
          </div>
        </div>
      </div>

      <div>
        <label class="mt-2">{{ $t("file-manager.file-category.parent") }}</label>
        <filter-select
          id="parentCategoryFilter"
          ref="parentCategoryFilter"
          :placeholder="$t('file-manager.file-category.parent')"
          :multiple="false"
          @filter="onParentCategorySearch"
          :selected="form.parentCategory"
          @changed="parentCategorySelect"
          track="_id"
        />
      </div>
      <div v-if="form.showChildCategory">
        <label class="mt-2">{{ $t("file-manager.file-category.text") }}</label>
        <i class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white" v-b-tooltip.hover :title="$t('file-manager.optional-category-info')"></i>
        <filter-select
          id="categoryFilter"
          ref="categoryFilter"
          :placeholder="$t('file-manager.file-category.text')"
          :multiple="false"
          @filter="onCategorySearch"
          @changed="categorySelect"
          track="_id"
        />
      </div>
      <div>
        <h6 class="mt-3">{{ $t("file-manager.admin") }}</h6>
        <organization-member-select :selected="form.admin" @onSelect="onMemberSelect" :organization="currentOrganization" :filterFunction="filterFunction" />
      </div>
      <div class="d-flex flew-row">
        <div class="">
          <b-form-checkbox switch v-model="form.isPeriodical" :value="true" :unchecked-value="false" class="custom-checkbox  mt-4 ">
            {{ $t("file-manager.periodic-review") }}
          </b-form-checkbox>
        </div>
        <div class="">
          <span v-if="form.isPeriodical">
            <input class="form-control input-sm mt-3 ml-4" v-model="form.period" type="number" min="1" layout="vertical" :placeholder="$t('policy.period')" />
          </span>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <sweet-button @click="save()" type="submit" :disabled="$v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>

      <div></div>
    </template>
  </b-modal>
</template>

<script>
import OrganizationMemberSelect from "@cc/organization-member-select";
import { required, requiredIf } from "vuelidate/lib/validators";
import FileRocket from "../../components/common/form/file-rocket.vue";
const state = "fileManager";

export default {
  props: ["id", "fileManagerDirectoryType"],
  components: { FileRocket, OrganizationMemberSelect },
  data() {
    return {
      form: {
        showChildCategory: false,
        fileNoOption: "select",
        fileNo: undefined,
        parentCategory: undefined,
        category: undefined,
        admin: undefined,
        isPeriodical: false,
        period: undefined,
      },
    };
  },

  validations: {
    form: {
      parentCategory: {
        required,
        // requiredIf: requiredIf((form) => {
        //   return !!form.category;
        // }),
      },
      admin: {
        required,
      },

      fileNo: {
        required,
      },
    },
  },
  watch: {
    "form.parentCategory._id": {
      deep: true,

      handler(v) {
        if (v) {
          this.form.showChildCategory = true;
          this.$refs?.categoryFilter?.reset(v);
        } else {
          this.form.showChildCategory = false;
          this.form.category = undefined;
        }
      },
    },
  },

  methods: {
    onMemberSelect(item) {
      this.form.admin = item;
    },
    filterFunction(item) {
      const permissionFilter = new Set([
        "ORGANIZATION_ADMIN",
        "ORGANIZATION_GDPR_PRODUCT_ADMIN",
        "ORGANIZATION_KVKK_ACCESS",
        "ORGANIZATION_GDPR_ACCESS",
        "ORGANIZATION_BGYS_ACCESS",
        "ORGANIZATION_DDO_ACCESS",
        "ORGANIZATION_KVKK_PRODUCT_ADMIN",
        "ORGANIZATION_BGYS_PRODUCT_ADMIN",
        "ORGANIZATION_DDO_PRODUCT_ADMIN",
        "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
        "ORGANIZATION_RISK_ADMIN",
        "ORGANIZATION_LEGAL_ADMIN",
      ]);

      const hasValidRole = item.accessable && item.roles?.some((role) => role.permissions?.some((permission) => permissionFilter.has(permission)));

      return item.isDepartmentAdmin || item.isProcessAdmin || item.isOwner || hasValidRole;
    },
    onHide() {
      this.form.fileNo = undefined;
      this.form.category = undefined;
      this.$emit("closed");
    },
    async onNoSearch(value, callback) {
      const response = await this.$store.dispatch(`${state}/paginateFileForNos`, {
        options: { limit: 200 },
        query: {
          name: { value },
          no: { value: { $exists: true }, isObject: true },
          admin: { value: this.currentAccount._id, isObject: true },
          latest: { value: true, isObject: true },
        },
      });

      callback(response.data?.docs.map((i) => ({ name: { tr: i.no, en: i.no, de: i.no, fr: i.no }, fileName: i.name })) ?? []);
    },
    async noSelect(item) {
      if (!item) {
        this.form.fileNo = undefined;
        return;
      }
      const response = await this.$store.dispatch(`${state}/paginateFileForNos`, {
        options: { limit: 200 },
        query: { no: { value: { $exists: true }, isObject: true } },
      });
      const file = response.data?.docs.find((i) => i.no == item.name.tr);
      delete file._id;
      delete file.history;
      this.form = { ...this.prepareFormForEdit({ ...this.form, ...file }) };
      if (this.form.category) {
        if (this.form.category.parent) {
          this.form.parentCategory = this.form.category.parent;
        } else {
          this.form.parentCategory = this.form.category;
          this.form.category = undefined;
        }
        this.showChildCategory = true;
        this.$refs?.categoryFilter?.reset();
      }
      this.$v.form.$touch();
      this.$forceUpdate();
      this.form.fileNo = item?.name?.[this.currentLanguage];
    },
    async onParentCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationFileCategory/paginate`, {
        options: { limit: 200, sort: { [`name.${this.currentLanguage}`]: "asc" } },
        query: { name: { value }, products: { value: { $in: this.accessableProducts || [] }, isObject: true }, parent: { value: { $exists: false }, isObject: true } },
      });

      callback(response.data?.docs ?? []);
    },
    parentCategorySelect(item) {
      this.form.parentCategory = item;
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationFileCategory/paginate`, {
        options: { limit: 200, sort: { [`name.${this.currentLanguage}`]: "asc" } },
        query: { name: { value }, products: { value: { $in: this.accessableProducts || [] }, isObject: true }, parent: { value: this.form.parentCategory._id, isObject: true } },
      });
      callback(response.data?.docs ?? []);
    },
    categorySelect(item) {
      this.form.category = item;
    },
    save() {
      if (this.form.parentCategory) {
        if (this.form.category) {
          delete this.form.parentCategory;
        } else {
          this.form.category = this.form.parentCategory;
        }
      }

      this.$emit("selected", { category: this.form.category, fileNo: this.form.fileNo, admin: this.form.admin, isPeriodical: this.form.isPeriodical, period: this.form.period });
      this.$bvModal.hide("fileNoAndCategorySelect");
    },
  },
};
</script>

<style>
.pcard--actions {
  display: flex;
  gap: 0.75rem;
  font-size: 1.5rem;
  margin-left: 0.75rem;

  i {
    cursor: pointer;
    transition: color 0.3s;
  }

  i:hover {
    color: #ff7c48;
  }
}
.disabled-pcard--actions {
  display: flex;
  gap: 0.75rem;
  font-size: 1.5rem;
  margin-left: 0.75rem;

  i {
    transition: color 0.3s;
    color: #7e7e7e;
  }
}

.add-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ff7c48;
  text-align: right;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.multiselect--active {
  z-index: 9999999999 !important;
}
.multiselect__content-wrapper {
  position: relative !important;
}
</style>
